/* =====================================================================
   Pigmenta — MPX FX  (تأثيرات "إضافة للسلة" و"المفضلة")
   ---------------------------------------------------------------------
   مبادئ السلامة المتّبعة في هذا الملف (مهمة عند أي صيانة مستقبلية):

   1) لا يُعدّل هذا الملف أي كود قائم في الثيم إطلاقاً، ولا يستبدل أي
      معالج أحداث موجود. يستمع فقط في مرحلة الالتقاط (capture) ولا يستدعي
      preventDefault ولا stopPropagation، فتبقى وظائف الأزرار كما هي.
   2) لا يُدخل أي عنصر HTML داخل أزرار الثيم. كل الرسم يتم في طبقة
      مستقلة مثبّتة فوق الصفحة، فلا يتأثر أي تنسيق (Flex/Grid) قائم.
   3) لا يلمس خاصية transform لأي زر (لأن الثيم يستخدمها في hover)،
      بل يستخدم الخصائص المستقلة scale / translate التي تتراكب معها.
   4) يلتقط نجاح الإضافة للسلة عبر مراقبة استجابة /cart/add.js بشكل
      "مرور فقط" (pass-through) دون قراءة أو استهلاك محتوى الاستجابة،
      فتعمل كل أكواد السلة الموجودة في الثيم والبلوكات كما هي.
   5) عند أي متصفح قديم أو تفضيل "تقليل الحركة" يتوقف الملف بهدوء
      تاركاً المتجر يعمل بشكل طبيعي 100%.
   ===================================================================== */

(function () {
  'use strict';

  var CFG = window.mpxFx || {};
  if (CFG.enabled === false) return;
  if (!window.Element || !Element.prototype.animate) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.__mpxFxLoaded) return;
  window.__mpxFxLoaded = true;

  /* ================== إعدادات ================== */

  var speedPct = parseInt(CFG.speed, 10);
  if (isNaN(speedPct) || speedPct < 40 || speedPct > 200) speedPct = 100;
  var SPEED = speedPct / 100;

  var OPT = {
    ripple: CFG.ripple !== false,
    fly: CFG.fly !== false,
    burst: CFG.burst !== false,
    heartFly: CFG.heartFly !== false,
    haptics: CFG.haptics !== false
  };

  function D(ms) { return Math.max(60, Math.round(ms / SPEED)); }

  function cssVar(name, fallback) {
    try {
      var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
      return v || fallback;
    } catch (e) { return fallback; }
  }

  var C1 = CFG.color1 || cssVar('--color-primary', '#F9B2D7');
  var C2 = CFG.color2 || cssVar('--color-primary-dark', '#6B2049');
  var C3 = CFG.color3 || '#FFD86B';
  var PALETTE = [C1, C2, C3, C1, C3, C2];

  var EASE_OUT = 'cubic-bezier(.16,.84,.34,1)';
  var EASE_IN = 'cubic-bezier(.5,0,.9,.55)';
  var EASE_POP = 'cubic-bezier(.34,1.56,.64,1)';

  /* ================== الطبقة المستقلة ================== */

  var layer = null;
  function getLayer() {
    if (layer && document.body && document.body.contains(layer)) return layer;
    if (!document.body) return null;
    layer = document.createElement('div');
    layer.className = 'mpx-fx-layer';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);
    return layer;
  }

  function add(el) {
    var l = getLayer();
    if (!l) return null;
    l.appendChild(el);
    return el;
  }

  function drop(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  /* عدد الجزيئات النشطة — حماية من أي تراكم على الأجهزة الضعيفة */
  var liveCount = 0;
  function budgetOk(n) {
    if (liveCount > 90) return false;
    liveCount += n;
    return true;
  }
  function release(n) {
    liveCount = Math.max(0, liveCount - n);
  }

  /* ================== أدوات هندسية ================== */

  function rectOf(el) {
    try { return el.getBoundingClientRect(); } catch (e) { return null; }
  }

  function isPaintable(el) {
    if (!el) return false;
    var r = rectOf(el);
    if (!r || !r.width || !r.height) return false;
    var cs;
    try { cs = getComputedStyle(el); } catch (e) { return false; }
    if (cs.visibility === 'hidden' || cs.display === 'none') return false;
    if (parseFloat(cs.opacity || '1') < 0.05) return false;
    return true;
  }

  /* يختار أنسب هدف ظاهر فعلاً على الشاشة (الهيدر أو شريط الجوال السفلي) */
  function visibleTarget(selector) {
    var nodes = document.querySelectorAll(selector);
    var best = null, bestScore = -1;
    var vh = window.innerHeight || 0, vw = window.innerWidth || 0;
    for (var i = 0; i < nodes.length; i++) {
      var host = nodes[i].closest('a,button') || nodes[i];
      if (!isPaintable(host)) continue;
      var r = rectOf(host);
      var inView = r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
      var score = (inView ? 1000 : 0) + r.width;
      if (score > bestScore) { bestScore = score; best = host; }
    }
    return best;
  }

  function cartTarget() {
    return visibleTarget('[data-cart-count]') || visibleTarget('a[href$="/cart"], a[href*="/cart?"], .cart-link');
  }

  function wishTarget() {
    return visibleTarget('[data-wishlist-count]') || visibleTarget('.wishlist-nav-link');
  }

  /* ================== صندوق تراكب فوق زر (بدون لمس الزر) ================== */

  function boxOver(el, extraClass) {
    var r = rectOf(el);
    if (!r || !r.width) return null;
    var cs = getComputedStyle(el);
    var box = document.createElement('div');
    box.className = 'mpx-fx-ripplebox' + (extraClass ? ' ' + extraClass : '');
    box.style.left = r.left + 'px';
    box.style.top = r.top + 'px';
    box.style.width = r.width + 'px';
    box.style.height = r.height + 'px';
    box.style.borderRadius = cs.borderRadius || '0px';
    return add(box);
  }

  /* هل خلفية الزر فاتحة؟ (لاختيار لون الموجة المناسب) */
  function isLightSurface(el) {
    var cs = getComputedStyle(el);
    var m = (cs.backgroundColor || '').match(/rgba?\(([^)]+)\)/);
    if (!m) return true;
    var p = m[1].split(',').map(parseFloat);
    var a = p.length > 3 ? p[3] : 1;
    if (a < 0.25) return true; /* شفاف: نفترض خلفية فاتحة */
    var lum = (0.299 * p[0] + 0.587 * p[1] + 0.114 * p[2]) / 255;
    return lum > 0.62;
  }

  /* ================== 1) موجة الضغط ================== */

  function ripple(el, x, y) {
    if (!OPT.ripple) return;
    var box = boxOver(el);
    if (!box) return;
    var r = rectOf(el);
    var light = isLightSurface(el);
    box.style.color = light ? C2 : '#ffffff';

    var size = Math.max(r.width, r.height) * 2.1;
    var dot = document.createElement('span');
    dot.className = 'mpx-fx-ripple';
    dot.style.width = size + 'px';
    dot.style.height = size + 'px';
    dot.style.left = (x - r.left - size / 2) + 'px';
    dot.style.top = (y - r.top - size / 2) + 'px';
    box.appendChild(dot);

    var anim = dot.animate(
      [
        { transform: 'scale(0)', opacity: light ? 0.28 : 0.42 },
        { transform: 'scale(1)', opacity: 0 }
      ],
      { duration: D(620), easing: EASE_OUT }
    );
    anim.onfinish = function () { drop(box); };
    anim.oncancel = function () { drop(box); };
  }

  /* هل يدعم المتصفح الخصائص المستقلة scale/translate؟
     نستخدمها لأنها تتراكب مع transform الموجود في الثيم بدل أن تلغيه.
     في المتصفحات القديمة نعود إلى transform — لكن فقط للعناصر الآمنة
     (أيقونات الهيدر والعدّادات) التي لا تملك transform في تنسيق الثيم. */
  var HAS_INDEPENDENT = (function () {
    try { return !!(window.CSS && CSS.supports && CSS.supports('scale', '1')); }
    catch (e) { return false; }
  })();

  function pressSqueeze(el) {
    if (!HAS_INDEPENDENT) return;
    try {
      el.animate(
        [{ scale: '1' }, { scale: '0.94' }, { scale: '1' }],
        { duration: D(320), easing: EASE_OUT }
      );
    } catch (e) {}
  }

  function popScale(el, peak, safeForTransform) {
    var p = String(peak || 1.28);
    try {
      if (HAS_INDEPENDENT) {
        el.animate(
          [{ scale: '1' }, { scale: p }, { scale: '0.96' }, { scale: '1' }],
          { duration: D(560), easing: EASE_POP }
        );
      } else if (safeForTransform) {
        el.animate(
          [
            { transform: 'scale(1)' }, { transform: 'scale(' + p + ')' },
            { transform: 'scale(.96)' }, { transform: 'scale(1)' }
          ],
          { duration: D(560), easing: EASE_POP }
        );
      }
    } catch (e) {}
  }

  function shake(el) {
    if (!HAS_INDEPENDENT) return;
    try {
      el.animate(
        [
          { translate: '0px' }, { translate: '-5px' }, { translate: '5px' },
          { translate: '-3px' }, { translate: '3px' }, { translate: '0px' }
        ],
        { duration: D(420), easing: 'ease-in-out' }
      );
    } catch (e) {}
  }

  function buzz(ms) {
    if (!OPT.haptics) return;
    try { if (navigator.vibrate) navigator.vibrate(ms || 10); } catch (e) {}
  }

  /* ================== 2) حلقة نابضة + جزيئات ================== */

  function ring(cx, cy, size, color, soft) {
    var el = document.createElement('div');
    el.className = 'mpx-fx-ring' + (soft ? ' mpx-fx-ring--soft' : '');
    el.style.width = size + 'px';
    el.style.height = size + 'px';
    el.style.left = (cx - size / 2) + 'px';
    el.style.top = (cy - size / 2) + 'px';
    el.style.color = color;
    if (!add(el)) return;
    var a = el.animate(
      [
        { transform: 'scale(.35)', opacity: .75 },
        { transform: 'scale(1.9)', opacity: 0 }
      ],
      { duration: D(720), easing: EASE_OUT }
    );
    a.onfinish = a.oncancel = function () { drop(el); };
  }

  function heartNode(color, size) {
    var d = document.createElement('div');
    d.className = 'mpx-fx-heart';
    d.style.width = size + 'px';
    d.style.height = size + 'px';
    d.style.color = color;
    d.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 20s-7-4.4-9.3-8.8C1.2 8 2.6 4.8 5.7 4.1 8 3.6 10 4.7 12 7c2-2.3 4-3.4 6.3-2.9 3.1.7 4.5 3.9 3 6.9C19 15.6 12 20 12 20Z"/></svg>';
    return d;
  }

  function sparkNode(color, size) {
    var d = document.createElement('div');
    d.className = 'mpx-fx-spark';
    d.style.width = size + 'px';
    d.style.height = size + 'px';
    d.style.color = color;
    d.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 0c.7 5.9 5.4 10.6 12 12-6.6 1.4-11.3 6.1-12 12-.7-5.9-5.4-10.6-12-12C6.6 10.6 11.3 5.9 12 0Z"/></svg>';
    return d;
  }

  /* انفجار جزيئات لطيف حول نقطة معيّنة */
  function burst(cx, cy, opts) {
    if (!OPT.burst) return;
    opts = opts || {};
    var count = opts.count || 10;
    if (!budgetOk(count)) return;

    var spread = opts.spread || 74;
    var gravity = opts.gravity == null ? 34 : opts.gravity;
    var kind = opts.kind || 'mix';
    var baseAngle = opts.baseAngle == null ? -Math.PI / 2 : opts.baseAngle;
    var arc = opts.arc == null ? Math.PI * 2 : opts.arc;
    var done = 0;

    for (var i = 0; i < count; i++) {
      var color = PALETTE[i % PALETTE.length];
      var size, node;
      var t = count > 1 ? (i / (count - 1)) : .5;
      var angle = baseAngle - arc / 2 + arc * t + (Math.random() - 0.5) * 0.45;
      var dist = spread * (0.55 + Math.random() * 0.75);
      var dx = Math.cos(angle) * dist;
      var dy = Math.sin(angle) * dist;

      if (kind === 'hearts' || (kind === 'mix' && i % 3 === 0)) {
        size = 9 + Math.random() * 8;
        node = heartNode(color, size);
      } else if (kind === 'sparks' || (kind === 'mix' && i % 3 === 1)) {
        size = 7 + Math.random() * 7;
        node = sparkNode(color, size);
      } else {
        size = 5 + Math.random() * 6;
        node = document.createElement('div');
        node.className = 'mpx-fx-dot';
        node.style.width = size + 'px';
        node.style.height = size + 'px';
        node.style.background = color;
      }

      node.style.left = (cx - size / 2) + 'px';
      node.style.top = (cy - size / 2) + 'px';
      if (!add(node)) { release(count); return; }

      var spin = (Math.random() * 200 - 100).toFixed(0);
      var dur = D(620 + Math.random() * 340);

      var a = node.animate(
        [
          { transform: 'translate(0,0) scale(.2) rotate(0deg)', opacity: 0 },
          { transform: 'translate(' + (dx * .55).toFixed(1) + 'px,' + (dy * .55).toFixed(1) + 'px) scale(1) rotate(' + (spin / 2) + 'deg)', opacity: 1, offset: .32 },
          { transform: 'translate(' + dx.toFixed(1) + 'px,' + (dy + gravity).toFixed(1) + 'px) scale(.25) rotate(' + spin + 'deg)', opacity: 0 }
        ],
        { duration: dur, easing: EASE_OUT, delay: Math.round(Math.random() * 60) }
      );
      /* eslint-disable no-loop-func */
      a.onfinish = a.oncancel = (function (n) {
        return function () {
          drop(n);
          done++;
          if (done >= count) release(count);
        };
      })(node);
    }
  }

  /* ================== 3) شارة ✓ ================== */

  function checkPop(cx, cy, color) {
    var size = 34;
    var el = document.createElement('div');
    el.className = 'mpx-fx-check';
    el.style.width = size + 'px';
    el.style.height = size + 'px';
    el.style.left = (cx - size / 2) + 'px';
    el.style.top = (cy - size / 2) + 'px';
    el.style.background = color || '#2e8b57';
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    if (!add(el)) return;
    var a = el.animate(
      [
        { transform: 'scale(0) rotate(-25deg)', opacity: 0 },
        { transform: 'scale(1.15) rotate(0deg)', opacity: 1, offset: .35 },
        { transform: 'scale(1) rotate(0deg)', opacity: 1, offset: .7 },
        { transform: 'scale(.85) rotate(0deg)', opacity: 0 }
      ],
      { duration: D(1100), easing: EASE_OUT }
    );
    a.onfinish = a.oncancel = function () { drop(el); };
  }

  /* ================== 4) لمعة النجاح فوق الزر ================== */

  function sheen(el) {
    var box = boxOver(el);
    if (!box) return;
    var sh = document.createElement('span');
    sh.className = 'mpx-fx-sheen';
    box.appendChild(sh);
    var a = sh.animate(
      [
        { transform: 'translateX(-160%) skewX(-18deg)' },
        { transform: 'translateX(260%) skewX(-18deg)' }
      ],
      { duration: D(760), easing: 'cubic-bezier(.3,.7,.3,1)' }
    );
    a.onfinish = a.oncancel = function () { drop(box); };
  }

  /* ================== 5) الطيران نحو السلة / المفضلة ================== */

  function pickSourceImage(btn) {
    /* صفحة المنتج: الصورة الرئيسية */
    var main = document.getElementById('MainProductImage');
    if (main && btn.closest && btn.closest('.product-section, form[action*="/cart/add"]') && isPaintable(main)) {
      return main;
    }
    var br = rectOf(btn);
    if (!br) return null;
    var bcx = br.left + br.width / 2, bcy = br.top + br.height / 2;

    var node = btn, depth = 0;
    while (node && node !== document.body && depth < 8) {
      var imgs = node.querySelectorAll ? node.querySelectorAll('img') : [];
      var best = null, bestDist = Infinity;
      for (var i = 0; i < imgs.length; i++) {
        var r = rectOf(imgs[i]);
        if (!r || r.width * r.height < 3600) continue;
        var dist = Math.hypot(r.left + r.width / 2 - bcx, r.top + r.height / 2 - bcy);
        if (dist < bestDist) { bestDist = dist; best = imgs[i]; }
      }
      if (best && bestDist < 700) return best;
      node = node.parentElement;
      depth++;
    }
    return null;
  }

  /* يبني العنصر الطائر ويسيّره على قوس ناعم:
     الغلاف يتكفّل بالمحور الأفقي، والداخل بالمحور الرأسي —
     تركيب المنحنيَين ينتج مسار قوسي طبيعي بدون أي حسابات إطار بإطار. */
  function flyTo(startRect, target, opts, onArrive) {
    opts = opts || {};
    if (!target || !startRect) { if (onArrive) onArrive(); return; }
    var tr = rectOf(target);
    if (!tr || !tr.width) { if (onArrive) onArrive(); return; }

    var w = Math.max(34, Math.min(opts.size || 96, startRect.width || 96));
    var h = w;
    var sx = startRect.left + startRect.width / 2;
    var sy = startRect.top + startRect.height / 2;
    var tx = tr.left + tr.width / 2;
    var ty = tr.top + tr.height / 2;
    var dx = tx - sx;
    var dy = ty - sy;

    var wrap = document.createElement('div');
    wrap.className = 'mpx-fx-flywrap';
    wrap.style.width = w + 'px';
    wrap.style.height = h + 'px';
    wrap.style.left = sx + 'px';
    wrap.style.top = sy + 'px';
    wrap.style.marginLeft = (-w / 2) + 'px';
    wrap.style.marginTop = (-h / 2) + 'px';

    var inner;
    if (opts.node) {
      inner = opts.node;
      inner.style.position = 'relative';
      inner.style.left = '0';
      inner.style.top = '0';
      inner.style.width = '100%';
      inner.style.height = '100%';
    } else {
      inner = document.createElement('div');
      inner.className = 'mpx-fx-fly' + (opts.image ? '' : ' mpx-fx-fly--plain');
      if (opts.image) {
        inner.style.backgroundImage = 'url("' + opts.image.replace(/"/g, '\\"') + '")';
      } else {
        inner.style.background = 'linear-gradient(135deg,' + C1 + ',' + C2 + ')';
      }
    }
    wrap.appendChild(inner);
    if (!add(wrap)) { if (onArrive) onArrive(); return; }

    var dur = D(opts.duration || 780);

    /* المحور الأفقي: يبدأ هادئاً ثم يتسارع نحو الأيقونة */
    var aX = wrap.animate(
      [{ transform: 'translateX(0px)' }, { transform: 'translateX(' + dx.toFixed(1) + 'px)' }],
      { duration: dur, easing: EASE_IN, fill: 'forwards' }
    );

    /* المحور الرأسي: يرتفع سريعاً في البداية ثم يستقر — مع تصغير وتدوير */
    var aY = inner.animate(
      [
        { transform: 'translateY(0px) scale(1) rotate(0deg)', opacity: 1, borderRadius: '16px', offset: 0 },
        { transform: 'translateY(' + (dy * 0.18 - 26).toFixed(1) + 'px) scale(1.08) rotate(-5deg)', opacity: 1, borderRadius: '18px', offset: 0.18 },
        { transform: 'translateY(' + (dy * 0.72).toFixed(1) + 'px) scale(.55) rotate(-9deg)', opacity: 1, borderRadius: '30%', offset: 0.72 },
        { transform: 'translateY(' + dy.toFixed(1) + 'px) scale(.16) rotate(-14deg)', opacity: .2, borderRadius: '50%', offset: 1 }
      ],
      { duration: dur, easing: EASE_OUT, fill: 'forwards' }
    );

    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      try { aX.cancel(); } catch (e) {}
      try { aY.cancel(); } catch (e) {}
      drop(wrap);
      if (onArrive) onArrive();
    }
    aY.onfinish = finish;
    aY.oncancel = finish;
    /* شبكة أمان: لو أُوقفت الحركة لأي سبب (تبديل تبويب مثلاً) */
    setTimeout(finish, dur + 900);
  }

  /* احتفال وصول العنصر إلى الأيقونة */
  function celebrate(target, badgeSelector, tone) {
    if (!target) return;
    var r = rectOf(target);
    if (!r) return;
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;

    /* أيقونات الهيدر/الشريط السفلي والعدّادات لا تملك transform في تنسيق
       الثيم، لذا يُسمح لها بالبديل عبر transform في المتصفحات القديمة. */
    popScale(target, 1.32, true);
    ring(cx, cy, Math.max(r.width, r.height) + 16, tone || C2);
    burst(cx, cy, { count: 8, spread: 46, gravity: 16, kind: tone === C1 ? 'hearts' : 'mix' });

    var badge = target.querySelector ? target.querySelector(badgeSelector) : null;
    if (badge) {
      setTimeout(function () { popScale(badge, 1.55, true); }, 90);
    }
  }

  /* ================== كشف الأزرار ================== */

  var ATC_SELECTOR = [
    '[data-quick-add]',
    '[data-add-to-cart]',
    '[data-add-to-cart-btn]',
    '[data-product-submit-btn]',
    'button[name="add"]',
    '.quick-add',
    '.add-to-cart-btn',
    '[class*="add-to-cart"]',
    '[class*="addtocart"]',
    '[class*="add-cart"]',
    '[class*="add-btn"]',
    '[class*="atc-btn"]'
  ].join(',');

  var WISH_SELECTOR = [
    '[data-wishlist-toggle]',
    '.wishlist-btn',
    '[class*="wishlist-btn"]',
    '[class*="wishlist-toggle"]',
    '[class*="wishlist__btn"]',
    '[class*="favorite-btn"]'
  ].join(',');

  function actionable(el) {
    if (!el || !el.tagName) return false;
    var tag = el.tagName.toLowerCase();
    return tag === 'button' || tag === 'a' || tag === 'input' || el.getAttribute('role') === 'button';
  }

  function matchButton(target, selector) {
    if (!target || !target.closest) return null;
    var el = target.closest(selector);
    if (!el) return null;
    if (!actionable(el)) {
      /* ربما الحاوية هي التي طابقت الاسم — نبحث عن الزر الفعلي داخل الحدث */
      el = target.closest('button,a,[role="button"]');
      if (!el || !el.matches || !el.matches(selector)) return null;
    }
    if (el.disabled) return null;
    return el;
  }

  /* ================== تتبّع آخر ضغطة "إضافة للسلة" ================== */

  var lastAdd = null;

  function rememberAdd(btn) {
    var img = pickSourceImage(btn);
    lastAdd = {
      btn: btn,
      at: Date.now(),
      rect: img ? rectOf(img) : rectOf(btn),
      image: img ? (img.currentSrc || img.src || '') : '',
      used: false
    };
  }

  function runCartSuccess() {
    var ctx = (lastAdd && !lastAdd.used && (Date.now() - lastAdd.at) < 6000) ? lastAdd : null;
    if (ctx) ctx.used = true;

    var target = cartTarget();

    if (ctx && ctx.btn && document.contains(ctx.btn)) {
      sheen(ctx.btn);
      popScale(ctx.btn, 1.05);
      var br = rectOf(ctx.btn);
      if (br) checkPop(br.left + 10, br.top + 8, C2);
    }

    if (!target) {
      if (ctx && ctx.rect) burst(ctx.rect.left + ctx.rect.width / 2, ctx.rect.top + ctx.rect.height / 2, { count: 10 });
      return;
    }

    if (OPT.fly && ctx && ctx.rect) {
      flyTo(ctx.rect, target, { image: ctx.image, size: 92, duration: 780 }, function () {
        celebrate(target, '[data-cart-count]', C2);
        buzz(14);
      });
    } else {
      celebrate(target, '[data-cart-count]', C2);
    }
  }

  function runCartError() {
    if (lastAdd && lastAdd.btn && document.contains(lastAdd.btn)) {
      shake(lastAdd.btn);
      lastAdd.used = true;
    }
  }

  /* ================== المفضلة ================== */

  function isWishActive(btn) {
    return btn.classList.contains('is-active') ||
           btn.classList.contains('active') ||
           btn.classList.contains('is-added') ||
           btn.getAttribute('aria-pressed') === 'true';
  }

  function runWishlist(btn) {
    var r = rectOf(btn);
    if (!r) return;
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;

    /* نقرأ الحالة بعد أن ينتهي معالج الثيم الأصلي من التبديل */
    setTimeout(function () {
      var active = isWishActive(btn);
      var icon = btn.querySelector('svg') || btn.querySelector('[class*="icon"]');

      if (active) {
        buzz(12);
        if (icon) {
          try {
            icon.animate(
              [
                { transform: 'scale(1)' },
                { transform: 'scale(.55)', offset: .22 },
                { transform: 'scale(1.45)', offset: .55 },
                { transform: 'scale(.92)', offset: .78 },
                { transform: 'scale(1)' }
              ],
              { duration: D(620), easing: EASE_POP }
            );
          } catch (e) {}
        }
        ring(cx, cy, Math.max(r.width, r.height) + 10, C1);
        setTimeout(function () { ring(cx, cy, Math.max(r.width, r.height) + 26, C1, true); }, D(110));
        burst(cx, cy, { count: 12, spread: 70, gravity: 26, kind: 'hearts', baseAngle: -Math.PI / 2, arc: Math.PI * 1.5 });

        if (OPT.heartFly) {
          var wt = wishTarget();
          if (wt && wt !== btn && !wt.contains(btn)) {
            setTimeout(function () {
              flyTo(
                { left: cx - 16, top: cy - 16, width: 32, height: 32 },
                wt,
                { node: heartNode(C1, 30), size: 30, duration: 640 },
                function () { celebrate(wt, '[data-wishlist-count]', C1); }
              );
            }, D(150));
          }
        }
      } else {
        /* الإزالة من المفضلة: تفاعل هادئ ومحترم */
        if (icon) {
          try {
            icon.animate(
              [{ transform: 'scale(1)' }, { transform: 'scale(.72)', offset: .45 }, { transform: 'scale(1)' }],
              { duration: D(420), easing: EASE_OUT }
            );
          } catch (e) {}
        }
        ring(cx, cy, Math.max(r.width, r.height) + 8, '#b9a6ac', true);
      }
    }, 30);
  }

  /* ================== الاستماع للأحداث (مرحلة الالتقاط، بلا اعتراض) ================== */

  function onPointerDown(e) {
    if (e.button != null && e.button !== 0 && e.pointerType !== 'touch') return;
    var t = e.target;
    var btn = matchButton(t, ATC_SELECTOR) || matchButton(t, WISH_SELECTOR);
    if (!btn) return;
    var x = e.clientX, y = e.clientY;
    if (x == null || (x === 0 && y === 0)) {
      var r = rectOf(btn);
      if (r) { x = r.left + r.width / 2; y = r.top + r.height / 2; }
    }
    ripple(btn, x, y);
    pressSqueeze(btn);
    buzz(8);
  }

  function onClick(e) {
    var t = e.target;

    var wish = matchButton(t, WISH_SELECTOR);
    if (wish) { runWishlist(wish); return; }

    var atc = matchButton(t, ATC_SELECTOR);
    if (atc) { rememberAdd(atc); }
  }

  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('click', onClick, true);

  /* دعم لوحة المفاتيح (Enter/Space) للوصولية */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var el = document.activeElement;
    if (!el) return;
    if (matchButton(el, ATC_SELECTOR) || matchButton(el, WISH_SELECTOR)) pressSqueeze(el);
  }, true);

  /* ================== مراقبة نجاح الإضافة للسلة ================== */
  /* تغليف fetch بأسلوب "مرور فقط": نعيد نفس الوعد الأصلي للمستدعي،
     ونراقب نسخة جانبية منه فقط لمعرفة نجاح الطلب. لا نقرأ الجسم
     ولا نغيّر أي شيء، لذا تبقى أكواد السلة في الثيم والبلوكات سليمة. */

  (function wrapFetch() {
    if (!window.fetch || window.fetch.__mpxWrapped) return;
    var original = window.fetch;

    function wrapped(input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) { url = ''; }

      var promise = original.apply(this, arguments);

      if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        try {
          promise.then(function (res) {
            if (res && res.ok) {
              setTimeout(runCartSuccess, 0);
              try { document.dispatchEvent(new CustomEvent('mpx:cart-added')); } catch (e) {}
            } else {
              setTimeout(runCartError, 0);
            }
          }, function () {
            setTimeout(runCartError, 0);
          });
        } catch (e) {}
      }

      return promise;
    }

    wrapped.__mpxWrapped = true;
    try {
      window.fetch = wrapped;
    } catch (e) { /* لو مُنع التعديل: نتجاهل بهدوء */ }
  })();

  /* دعم إضافي: XMLHttpRequest (بعض التطبيقات الخارجية تستخدمه) */
  (function wrapXhr() {
    if (!window.XMLHttpRequest || XMLHttpRequest.prototype.__mpxWrapped) return;
    var openOrig = XMLHttpRequest.prototype.open;
    var sendOrig = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__mpxUrl = String(url || ''); } catch (e) {}
      return openOrig.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var self = this;
      try {
        if (self.__mpxUrl && /\/cart\/add(\.js)?(\?|$)/.test(self.__mpxUrl)) {
          self.addEventListener('load', function () {
            if (self.status >= 200 && self.status < 300) setTimeout(runCartSuccess, 0);
            else setTimeout(runCartError, 0);
          });
        }
      } catch (e) {}
      return sendOrig.apply(this, arguments);
    };

    XMLHttpRequest.prototype.__mpxWrapped = true;
  })();

  /* تنظيف الطبقة عند إخفاء الصفحة حتى لا تبقى أي حركة معلّقة */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden && layer) {
      layer.innerHTML = '';
      liveCount = 0;
    }
  });
})();
